<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>


    <div v-show="!showEdicao">
        <div class="form-edit-page row row-space">
            <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentMonth'" v-model="dateRange" ref="dateRangeSelect" /></div>
            <div class="form-item">
                <EquipamentoFrame v-model:objSelecionado="equipamentoSelecionado"/>
            </div>
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--close" @click="closePage" />
        </div>

        <div v-show="lsDados.length>0" class="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th>Km/Horas</th>
                        <th>Intervalo</th>
                        <th>Data</th>
                        <th>Hora</th>
                        <th>Tipo Registro</th>
                        <th>Evento</th>
                        <th>Nome/Operador</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                        @click="setEdicao(obj)"
                    >
                        <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.kmhoras,1) }}</td>
                        <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.intervalo,1) }}</td>
                        <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtevento) }}</td>
                        <td class="col-width-char10 center">{{ Funcoes.formatTimeFromJson(obj.hrevento) }}</td>
                        <td class="col-width-char30">{{ obj.prefixo }}</td>
                        <td>{{ obj.nmevento }}</td>
                        <td class="col-width-char40">{{ obj.nmcomplemento }}</td>
                    </tr>
                </tbody>
            </table>
        </div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>



    <div v-if="showEdicao">
        <div class="form-edit-page">
            <div class="row row-space">                
                <div class="form-item">
                    <label class="label-caption">Equipamento</label>
                    <div class="field-label field-label--destaque">{{ itemSelecionado.nmequipamento }}</div>
                </div>
            </div>

            
            <div class="row row-space">
                <div class="form-item-char20">
                    <label class="label-caption">Tipo</label>
                    <div class="field-label field-label-center">{{ itemSelecionado.prefixo }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Evento</label>
                    <div class="field-label">{{ itemSelecionado.nmevento }}</div>
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Nome/Operador</label>
                    <div class="field-label">{{ itemSelecionado.nmcomplemento }}</div>
                </div>
            </div>

            
            <div class="row row-space">
                <div class="form-item-char20">
                    <label class="label-caption">Data/Hora Registro</label>
                    <div class="field-label field-label-center">
                        {{ Funcoes.formatDateFromJson(itemSelecionado.dtevento) }}
                        {{ Funcoes.formatTimeFromJson(itemSelecionado.hrevento) }}
                    </div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Valor Registrado</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatDecimal(itemSelecionado.kmhoras, 1) }}</div>
                </div>
                
                <div class="form-item-char20">
                    <label class="label-caption">Novo Valor</label>
                    <input v-model="edKmHoras" v-decimal type="text" class="input-right" />
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Justificativa</label>
                    <input type="text" v-model="edJustificativa" maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row-end">
                <button class="btn-small" @click="salvarAjuste()">Salvar</button>
                <button class="btn-small" @click="showEdicao=false">Voltar</button>
            </div>
        </div>
    </div>
</template>


<script setup>
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import EquipamentoFrame from '@/components/frames/EquipamentoFrame.vue';

const emit = defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "currentMonth" });
const equipamentoSelecionado = ref(null);
const isLoading = ref(false);
const msgAlerta = ref(null);
const showEdicao = ref(false);

const edKmHoras = ref(null);
const edJustificativa = ref(null);
const itemSelecionado = ref(null);


const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDados = ref([]);
const lsDadosMain = ref([]);
const showPagination = ref(false);


function closePage(){
    emit('close');
}

async function lerDados(){
    msgAlerta.value = validarPesquisa();
    if (msgAlerta.value) return;
    
    try{
        isLoading.value = true;
        const req = await Api.genericPost('/dados/equipamentos/extrato', {
            idmunicipio: globalStore.idmunicipio,
            idequipamento: equipamentoSelecionado.value?.id,
            datainicial: dateRange.value.startDate, 
            datafinal:dateRange.value.endDate});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function salvarAjuste(){
    console.log('inicio....');
    msgAlerta.value = validarFormulario();
    if (msgAlerta.value) return;
    console.log('final....');
    
    try {
        isLoading.value=true;

        const r = await Api.genericPost('/cad/exec_requisicao', {
            nmrequisicao: 'correcao_kmhoras',
            idmunicipio: globalStore.idmunicipio,
            idreferencia: itemSelecionado.value.idregistro,
            strparam1: itemSelecionado.value.nmtabela,
            strparam2: edJustificativa.value,
            double1: itemSelecionado.value.kmhoras,
            double2: Funcoes.decimalFromString(edKmHoras.value),
            idlogin: globalStore.idlogin
        });
        
        if (r.bolok !== 1) {
            msgAlerta.value = r.erro;
        }else{
            await lerDados();
            showEdicao.value=false;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


function setEdicao(item){
    edJustificativa.value = null;
    edKmHoras.value = null;
    itemSelecionado.value = item;
    showEdicao.value = true;
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


function validarFormulario(){
    let x = '';
    if (!edKmHoras.value) x += '\n-Informe novo valor';
    if (!edJustificativa.value || edJustificativa.value.trim==="") x += '\n-Informe justificativa';    
    if (x) return `Verifique os dados informados: ${x}`;
    return null;
}


function validarPesquisa(){
    let x = '';
    let r = Validar.intervaloDatas(dateRange.value.startDate, dateRange.value.endDate, true);
    if (!r.ok) x += `\n-${r.msg}`;
    if (!equipamentoSelecionado.value) x += '\n-Informe um equipamento';
    
    if (x) return `Verifique os dados informados: ${x}`;
    return null;
}
</script>